import { UPDATE_ALL } from "../MapViewController";
import { BBase, BEV_SHAPE_MAJOR_CHANGE, fetchAutoId } from "../model/BBase";

class BCommandBase {
	undo(_app) {
		console.log("%cWARNING: BASE CLASS INVOKED", "color: #F00");
	}

	execute(_app) {
		console.log("%cWARNING: BASE CLASS INVOKED", "color: #F00");
	}
}

class BAddItemCommand extends BCommandBase {
	constructor(serializedItem) {
		super();
		this.serializedItem = serializedItem;
	}

	execute(app) {
		add_from_serialized(app, this.serializedItem);
	}

	undo(app) {
		remove_with_serialized(app, this.serializedItem);
	}

	static generateSerializedDataTemplate(parentItem, klass, additional) {
		const o = {
			id: fetchAutoId(),
			flags: 0,
			className: klass.name
		};

		if (parentItem) {
			o._parent_id = parentItem.id;
		}

		return Object.assign(o, additional);
	}
}

class BRemoveItemCommand extends BCommandBase {
	constructor(serializedItem) {
		super();
		this.serializedItem = serializedItem;
	}

	execute(app) {
		remove_with_serialized(app, this.serializedItem);
	}

	undo(app) {
		add_from_serialized(app, this.serializedItem);
	}
}

class BShapeChangeCommand extends BCommandBase {
	constructor(serializedItem) {
		super();
		this.serializedItem = serializedItem;

		if (!Number.isFinite(serializedItem.id)) { throw new Error("Bad operation data [1]"); }
		if (!Number.isSafeInteger(serializedItem.loopIndex)) { throw new Error("Bad operation data [3]"); }
		if (!Array.isArray(serializedItem.new_coords)) { throw new Error("Bad operation data [3]"); }
		if (!Array.isArray(serializedItem.old_coords)) { throw new Error("Bad operation data [4]"); }
	}

	execute(app) {
		const ser = this.serializedItem;
		write_serialized_coords(app, ser.id, ser.loopIndex, ser.new_coords);
	}

	undo(app) {
		const ser = this.serializedItem;
		write_serialized_coords(app, ser.id, ser.loopIndex, ser.old_coords);
	}
}

function add_from_serialized(app, ser, pj) {
	if (!pj) {
		pj = app.getCurrentProject();
	}

	const inst = BBase.createDeserializedInstance(ser);
	inst.deserialize(ser);

	if (Number.isSafeInteger(ser._parent_id)) {
		const pr = pj.findById(ser._parent_id);
		if (inst.isBuilding) {
			pr.addBuilding(inst, ser._next_id);
		} else {
			pr.addItem(inst, ser._next_id);
		}
	}

	if (Array.isArray(ser.children)) {
		for (const cs of ser.children) {
			add_from_serialized(app, cs, pj);
		}
	}
}

function remove_with_serialized(app, ser) {
	const pj = app.getCurrentProject();
	const parent = pj.findById( ser._parent_id );
	const target = pj.findById( ser.id );

	parent.removeItem(target);

	if (ser._afterRemove?.editingFloor) {
		const state = {};
		state.editingFloor = ser._afterRemove.editingFloor;

		app.setState(state);
	}
}

function write_serialized_coords(app, id, loopIndex, coordinates) {
	const pj = app.getCurrentProject();
	const target = pj.findById( id );

	target.clearLoop(loopIndex).addCoordinatesFromArray(loopIndex, coordinates);
	target.fireLengthChange();
	target.fireCoodinateChange(0, 0);
}

class BMoveVertexCommand extends BCommandBase {
	constructor(operationData) {
		super();

		// Check required fields
		if (!Number.isFinite(operationData.id)) { throw new Error("Bad operation data [1]"); }
		if (!Number.isSafeInteger(operationData.loopIndex)) { throw new Error("Bad operation data [2]"); }
		if (!Number.isSafeInteger(operationData.index)) { throw new Error("Bad operation data [3]"); }
		if (!Array.isArray(operationData.old_pos)) { throw new Error("Bad operation data [4]"); }
		if (!Array.isArray(operationData.new_pos)) { throw new Error("Bad operation data [5]"); }

		this.operationData = operationData;
	}

	execute(app) {
		const op = this.operationData;
		mov_cmd(app, op.id, op.loopIndex, op.index, op.new_pos);
	}

	undo(app) {
		const op = this.operationData;
		mov_cmd(app, op.id, op.loopIndex, op.index, op.old_pos);
	}
}

class BAddLoopCommand extends BCommandBase {
	constructor(operationData) {
		super();

		if (!Number.isFinite(operationData.id)) { throw new Error("Bad operation data [1]"); }
		if (!Number.isSafeInteger(operationData.beforeThisIndex)) { throw new Error("Bad operation data [2]"); }
		if (!Array.isArray(operationData.new_loop)) { throw new Error("Bad operation data [3]"); }

		this.operationData = operationData;
	}

	execute(app) {
		const pj = app.getCurrentProject();
		const polygon_bitem = pj.findById( this.operationData.id );

		const op = this.operationData;
		polygon_bitem.addLoop(op.new_loop, op.beforeThisIndex);
		polygon_bitem.fireEvent(polygon_bitem, BEV_SHAPE_MAJOR_CHANGE);
	}

	undo(app) {
		const pj = app.getCurrentProject();
		const polygon_bitem = pj.findById( this.operationData.id );

		const op = this.operationData;
		polygon_bitem.removeLoop(op.beforeThisIndex);
		polygon_bitem.fireEvent(polygon_bitem, BEV_SHAPE_MAJOR_CHANGE);
	}
}

function mov_cmd(app, id, loopIndex, vIndex, pos) {
	const pj = app.getCurrentProject();
	const bitem = pj.findById( id );

	bitem.modifyCoordinate(loopIndex, vIndex, pos[1], pos[0], UPDATE_ALL);
}

export { BAddLoopCommand, BAddItemCommand, BRemoveItemCommand, BMoveVertexCommand, BShapeChangeCommand, add_from_serialized };